import * as React from 'react';

import { ChoicePopUp } from '../ChoicePopup';
import { ProblemIcon } from './icons/ProblemIcon';
import { ProblemLargeIcon } from './icons/ProblemLargeIcon';
import * as styles from './ProblemChoicePopup.css';

export interface IProblemChoicePopupProps {
  url: string;
}

export const ProblemChoicePopup: React.FC<IProblemChoicePopupProps> = ({ url }) => {
  return (
    <ChoicePopUp
      icon={<ProblemLargeIcon />}
      description="В ЖК есть проблемные корпуса."
      title="Будьте внимательны"
      url={url}
    >
      <span className={styles['icon']}>
        <ProblemIcon />
      </span>
    </ChoicePopUp>
  );
};
